import { useQuery } from 'react-query';
import { fetcher, baseApiUrl, ServerErrorResponse } from 'data_sources/constants';
import { CRQ } from 'views/App/Portal/Policy/_types/crq';

export default function useDraftManualCRQs(
  manualId?: string,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexiverse/manual-crq/v1/manuals/${manualId}/questions`;

  return useQuery<CRQ, ServerErrorResponse>(
    ['draft_manuals_crq', manualId],
    async (): Promise<CRQ> => {
      try {
        const data = await fetcher({
          method: 'get',
          url,
        });
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      enabled: !!manualId,
      keepPreviousData: true,
    }
  );
}
